import { useParams, Navigate } from "react-router-dom";
import { LessonViewer } from "@/features/learn/components/LessonViewer";
import { getLesson } from "@/features/learn/content";

const LessonPage = () => {
  const { lessonId } = useParams<{ lessonId: string }>();
  const lesson = lessonId ? getLesson(lessonId) : undefined;

  if (!lesson) {
    return <Navigate to="/learn" replace />;
  }

  // Key on lessonId to reset state when navigating between lessons
  return <LessonViewer key={lesson.id} lesson={lesson} />;
};

export default LessonPage;
